import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Input } from "@chakra-ui/react";

const CustomDateInput = ({ selectedDate, setSelectedDate }) => {
  const titleColor = "white";

  return (
    <Box
      w='100%'
      sx={{
        ".react-datepicker-wrapper": {
          display: "block",
          padding: "0",
          border: "0",
        },
        ".react-datepicker": {
          background: "rgb(19,21,54)",
          color: "white !important",
          borderRadius: "10px",
          border: "transparent",
        },
        ".react-datepicker__day--selected": {
          background: "rgb(41, 46, 150)",
          color: "white !important",
        },
        ".react-datepicker__day:hover": {
          background: "rgb(61, 67, 182)",
          color: "white !important",
        },
        ".react-datepicker__header": {
          backgroundColor: "rgb(19,21,54)",
          color: "white !important",
        },
        ".react-datepicker__current-month": {
          color: "white !important",
        },
        ".react-datepicker__day-name": {
          color: "white !important",
        },
        ".react-datepicker__day": {
          color: "white !important",
        },
        ".react-datepicker__day--keyboard-selected": {
          background: "rgb(41, 46, 150)",
          color: "white !important",
        },
      }}
    >
      <DatePicker
        selected={selectedDate}
        onChange={(date, event) => {
          event.target.blur();
          setSelectedDate(date);
        }}
        customInput={
          <Input
            value={selectedDate ? selectedDate.toLocaleDateString() : ""}
            placeholder={selectedDate ? "" : "Select Date"}
            sfontColor={titleColor}
            color={titleColor}
            bg={{
              base: "rgb(19,21,54)",
            }}
            border='transparent'
            borderRadius='20px'
            fontSize='sm'
            w={{ base: "100%", lg: "100%" }}
            maxW='100%'
            h='46px'
            _placeholder={{
              color: "white",
            }}
            _focus={{
              outline: "none",
              boxShadow: "0 0 0 2px #4FD1C5",
            }}
          />
        }
        dateFormat='dd/MM/yyyy'
      />
    </Box>
  );
};

export default CustomDateInput;
